import './App.css';
import GooglePlay from './GooglePlay.png';
import AppStore from './AppleStore.png';
import { useEffect, useMemo, useState } from 'react';
import { isMobile, isIOS, isAndroid } from 'react-device-detect';
import Loader from './components/Loader';
import { classLinkCallBack } from './server/server';

function App() {
	const [loading, setLoading] = useState(true);
	const [errorMessage, setErrorMessage] = useState('');
	const [user, setUser] = useState({});
	const [success, setSuccess] = useState(false);
	const [isAppInstalled, setAppIsInstalled] = useState(true);

	const pathName = window?.location?.pathname ?? '';
	const search = window?.location?.search ?? '';
	const mobileUrl = `upstriveeducation:/${pathName}?token=${user?.token}`;
	const isStudent = useMemo(() => user?.role === 0, [user]);
	const webUrl = !isStudent ? `https://web.upstrivesystem.com?token=${user?.token}` : `https://student.upstrivesystem.com?token=${user?.token}`;

	const searchParams = new URLSearchParams(window.location.search);
	const code = searchParams.get('code') ?? null;

	const iosAppStoreLink = 'https://apps.apple.com/us/app/upstrive-education/id1535688668';
	const androidPlayStoreLink = 'https://play.google.com/store/apps/details?id=com.mindmotionsfzlle.upstrive';
	const fallbackUrl = isIOS ? iosAppStoreLink : androidPlayStoreLink;

	useEffect(() => {
		if (code) checkCode();
	}, [code]);

	useEffect(() => {
		if (user.email) {
			openWebPage(isMobile ? mobileUrl : webUrl, 700);
		}
	}, [user]);

	const openWebPage = (url = webUrl, timeout = 0) => {
		setTimeout(() => {
			setLoading(false);

			window.open(url, '_self');
		}, timeout);
	};

	const checkCode = async () => {
		const resp = await classLinkCallBack(code);
		if (resp.status === 200 && !!resp.data) {
			setUser(resp.data);
			setSuccess(true);
		} else {
			setErrorMessage(resp?.data ?? 'User does not exist!');
			setLoading(false);
		}
	};

	return (
		<div className='mobile_only'>
			<div className='w-375 mx-auto'>
				<img src='https://files.upstrivesystem.com/public/upstrive_education_logo.png' alt='Upstrive Education logo' className='w-[375px] mt-50' />
			</div>
			{loading && (
				<div className='flex flex-col items-center gap-5 mt-10'>
					<h2 className='text-white font-bold text-2xl'>Identifying user</h2>
					<Loader />
				</div>
			)}
			{!loading && success && (
				<div className=''>
					<h1 className='text-2xl font-bold text-white text-center px-[10px] mt-[40px]'>Hi {user?.first_name}!</h1>
					<h1 className='text-xl font-medium text-white text-center px-[10px] mt-[40px]'>You will be automatically redirected to the app</h1>
					<div className='mb-[20px] mt-[40px] text-center'>
						<h2 className='text-lg font-medium text-white px-[10px]'>If you are still on this page,</h2>
						{isAppInstalled && (
							<a className='text-lg font-medium text-white px-[10px] mb-20 underline text-center self-center' href={isMobile ? mobileUrl : webUrl}>
								redirect to the app
							</a>
						)}
						{!isAppInstalled && isMobile && (
							<a className='text-lg font-medium text-white px-[10px] mb-20 underline text-center self-center' href={fallbackUrl}>
								download the app
							</a>
						)}
					</div>

					{isMobile && (
						<div>
							<h3 className='text-white font-bold text-lg text-center'>Mobile app: Upstrive Education</h3>
							<div className='flex justify-center gap-[0.5rem]'>
								<a href={iosAppStoreLink}>
									<img src={AppStore} className='w-36' alt='App Store' title='App Store' />
								</a>
								<a href={androidPlayStoreLink}>
									<img src={GooglePlay} className='w-[10rem]' alt='Google Store' title='Google Store' />
								</a>
							</div>
						</div>
					)}
				</div>
			)}

			{!loading && !success && (
				<div className=''>
					<h1 className='text-2xl font-bold text-[#FD7983] text-center px-[10px] mt-[40px]'>{errorMessage}</h1>
				</div>
			)}
		</div>
	);
}

export default App;
